import { api, setConfig, UPDATE_SUCCESS_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const applySettings = (data: PropertyType): Promise<string | void> =>
	api.post('/user/apply-settings', mapEntityToApi(data), setConfig(data)).then(() => {
		return UPDATE_SUCCESS_MESSAGE;
	});
